<template>
  <div class="premium-page-wrapper premium-dashboard">
    <!-- Background Floating Light Orbs -->
    <div class="glow-orb orb-1"></div>
    <div class="glow-orb orb-2"></div>

    <v-card class="premium-main-card elevation-2 hero-card mb-6" flat>
      <!-- Premium Title Section -->
      <div class="premium-header-section">
        <div class="hero-glow-effect"></div>

        <!-- Floating Decorative Ambient Icons -->
        <v-icon class="deco-icon icon-card" color="rgba(255, 255, 255, 0.08)"
          >mdi-card-account-details</v-icon
        >
        <v-icon class="deco-icon icon-receipt" color="rgba(255, 255, 255, 0.08)"
          >mdi-printer-outline</v-icon
        >
        <v-icon class="deco-icon icon-safe" color="rgba(255, 255, 255, 0.08)"
          >mdi-account-check-outline</v-icon
        >
        <v-icon class="deco-icon icon-coin" color="rgba(255, 255, 255, 0.08)"
          >mdi-shield-check-outline</v-icon
        >

        <!-- Ocean Wave Background Animation -->
        <div class="waves-container">
          <svg
            class="waves"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28"
            preserveAspectRatio="none"
            shape-rendering="auto"
          >
            <defs>
              <path
                id="gentle-wave"
                d="M-160 44c30 0 58-18 88-18s58 18 88 18 58-18 88-18 58 18 88 18v44h-352z"
              />
            </defs>
            <g class="parallax">
              <use
                xlink:href="#gentle-wave"
                x="48"
                y="0"
                fill="rgba(255, 255, 255, 0.05)"
              />
              <use
                xlink:href="#gentle-wave"
                x="48"
                y="3"
                fill="rgba(255, 255, 255, 0.08)"
              />
              <use
                xlink:href="#gentle-wave"
                x="48"
                y="5"
                fill="rgba(255, 255, 255, 0.03)"
              />
              <use
                xlink:href="#gentle-wave"
                x="48"
                y="7"
                fill="rgba(255, 255, 255, 0.07)"
              />
            </g>
          </svg>
        </div>

        <div
          class="premium-header-content relative-content d-flex align-center justify-space-between"
        >
          <div>
            <span class="premium-badge-top pulse-border">Executive Portal</span>
            <div class="d-flex align-center mt-1">
              <v-icon color="white" class="mr-3 pulse-animation" size="36"
                >mdi-card-account-details</v-icon
              >
              <h1 class="premium-page-title animate-title">{{ PageTitle }}</h1>
            </div>
            <p class="premium-page-subtitle animate-subtitle mt-2">
              {{ PageDescription }}
            </p>
          </div>
          <div>
            <v-btn
              fab
              small
              color="rgba(255, 255, 255, 0.15)"
              dark
              class="refresh-btn pulse-border"
              @click="refreshPageData"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <v-card-text class="premium-card-content">
        <v-container fluid class="px-0 py-0">
          <v-alert
            v-if="ErrorMessageTxtFlag == 1"
            type="error"
            dismissible
            class="premium-alert mb-6"
            border="left"
            elevation="2"
          >
            {{ ErrorMessageTxt }}
          </v-alert>

          <v-dialog
            v-model="editRecordPrompt"
            max-width="85%"
            content-class="premium-dialog"
          >
            <member-edit
              pageDescription="Edit Member Details"
              :editRecordPrompt="editRecordPrompt"
              @hideEditRecordPrompt="hideEditRecordPrompt"
              :recordIndex="recordToEdit"
              v-if="editRecordPrompt"
            ></member-edit>
          </v-dialog>

          <!-- Search Filter Panel -->
          <div class="premium-filter-panel glass-card">
            <div class="premium-panel-header mb-6">
              <v-icon color="white" class="mr-2">mdi-tune-vertical</v-icon>
              <span class="premium-panel-title">Query Criteria</span>
            </div>

            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              id="createForm"
              class="premium-form"
            >
              <v-row>
                <v-col cols="12" sm="6" lg="3" md="3">
                  <div class="premium-input-group">
                    <label class="premium-input-label">ID Card Status</label>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :items="IdCardTypeOptions"
                      :rules="IdCardTypeRules"
                      v-model="IdCardType"
                      dense
                      clearable
                      required
                      outlined
                      class="premium-select"
                      placeholder="Select status"
                    ></v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="3">
                  <div class="premium-input-group">
                    <label class="premium-input-label">Member Category</label>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :items="MemberTypeOptions"
                      :rules="MemberTypeRules"
                      v-model="MemberType"
                      dense
                      clearable
                      required
                      outlined
                      multiple
                      chips
                      deletable-chips
                      class="premium-select"
                      placeholder="Select categories"
                    ></v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="3">
                  <div class="premium-input-group">
                    <label class="premium-input-label"
                      >Download Photos Option</label
                    >
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :items="DownloadMemberPhotosOptions"
                      :rules="DownloadMemberPhotosRules"
                      v-model="DownloadMemberPhotos"
                      dense
                      clearable
                      required
                      outlined
                      class="premium-select"
                      placeholder="Select option"
                    ></v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="3" v-if="JciYearCodeFlag">
                  <div class="premium-input-group">
                    <label class="premium-input-label"
                      ><span class="text-danger">*</span> Target Year</label
                    >
                    <v-autocomplete
                      @change="getFormFieldOptions"
                      :reduce="(option) => option.value"
                      :items="JciYearCodeOptions"
                      :rules="JciYearCodeRules"
                      v-model="JciYearCode"
                      dense
                      clearable
                      required
                      outlined
                      class="premium-select"
                      placeholder="Select Year"
                    ></v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="3">
                  <div class="premium-input-group">
                    <label class="premium-input-label"
                      ><span class="text-danger">*</span> JCI Zone</label
                    >
                    <v-autocomplete
                      @change="getLomCodeOptions"
                      :reduce="(option) => option.value"
                      :items="ZoneCodeOptions"
                      :rules="ZoneCodeRules"
                      v-model="ZoneCode"
                      dense
                      clearable
                      required
                      outlined
                      class="premium-select"
                      placeholder="Select Zone"
                    ></v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="3">
                  <div class="premium-input-group">
                    <label class="premium-input-label"
                      >Local Organization (LO)</label
                    >
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :items="LomCodeOptions"
                      :rules="LomCodeRules"
                      v-model="LomCode"
                      dense
                      clearable
                      required
                      outlined
                      multiple
                      chips
                      deletable-chips
                      class="premium-select"
                      placeholder="Select LOMs"
                    ></v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <div class="premium-actions-row mt-4">
                <v-btn
                  :disabled="!valid"
                  class="premium-btn premium-btn-search px-8"
                  @click="searchForm"
                >
                  <v-icon left size="20">mdi-magnify</v-icon>
                  Search Database
                </v-btn>
              </div>
            </v-form>
          </div>

          <!-- Spinner and Empty States -->
          <div class="premium-state-container">
            <div class="premium-loader-wrapper" v-if="ProgessStart == 1">
              <div class="premium-shimmer-bar"></div>
              <div class="d-flex flex-column align-center py-12">
                <b-spinner
                  variant="primary"
                  type="grow"
                  class="premium-spinner mb-4"
                  style="width: 3rem; height: 3rem"
                ></b-spinner>
                <span class="premium-loader-text"
                  >Loading secure database records...</span
                >
              </div>
            </div>

            <div
              class="premium-empty-state py-12 text-center"
              v-if="tableData1.length == 0 && ProgessStart == 0"
            >
              <div class="premium-empty-icon-wrap mb-4">
                <v-avatar
                  color="rgba(21, 101, 192, 0.08)"
                  size="120"
                  class="pulse-border"
                >
                  <v-icon size="64" color="#1565c0">mdi-database-search</v-icon>
                </v-avatar>
              </div>
              <h3 class="premium-empty-title">Database Awaiting Query</h3>
              <p class="premium-empty-subtitle">
                Select filters above and click Search to display member records.
              </p>
            </div>
          </div>

          <!-- Results Section -->
          <div
            class="premium-results-section fade-in"
            v-if="tableData1.length > 0"
          >
            <div
              class="premium-actions-bar d-flex flex-wrap align-center justify-space-between mb-8"
            >
              <div class="premium-stats-group">
                <h3 class="premium-results-title">Search Results</h3>
                <div class="premium-badge-group mt-1">
                  <span class="premium-badge premium-badge-found">
                    <v-icon left size="14">mdi-database-check</v-icon>
                    {{ tableData1.length }} Records
                  </span>
                  <span
                    class="premium-badge premium-badge-selected ml-2"
                    v-if="selected1.length > 0"
                  >
                    <v-icon left size="14">mdi-checkbox-multiple-marked</v-icon>
                    {{ selected1.length }} Selected
                  </span>
                </div>
              </div>

              <div class="premium-btn-group d-flex flex-wrap">
                <v-btn
                  v-if="tableData1.length > 0 && IdCardType == 0"
                  class="premium-btn premium-btn-mark mr-2"
                  @click="updateConfirmAlert"
                >
                  <v-icon left size="18">mdi-card-bulleted-settings</v-icon>
                  Mark Issued
                </v-btn>

                <v-btn
                  v-if="DownloadFlag"
                  @click.prevent="
                    generateExcel(
                      tableData1,
                      ExcelFields,
                      ExcelFileName,
                      'My Worksheet'
                    )
                  "
                  class="premium-btn premium-btn-download-details mr-2"
                >
                  <v-icon left size="18">mdi-file-excel</v-icon>
                  Export Excel
                </v-btn>

                <v-btn
                  :href="ZipFileName"
                  target="_blank"
                  v-if="ZipDownloadFlag"
                  class="premium-btn premium-btn-download-photos mr-2"
                >
                  <v-icon left size="18">mdi-image-multiple</v-icon>
                  Photos ZIP
                </v-btn>

                <v-btn
                  :href="ZipQrFileName"
                  target="_blank"
                  v-if="ZipQrDownloadFlag"
                  class="premium-btn premium-btn-download-qr"
                >
                  <v-icon left size="18">mdi-qrcode</v-icon>
                  QRs ZIP
                </v-btn>
              </div>
            </div>

            <!-- Table Container -->
            <div class="premium-table-card elevation-1">
              <div
                class="premium-table-header-row px-6 py-4 d-flex align-center"
              >
                <v-icon color="indigo darken-1" class="mr-2"
                  >mdi-format-list-bulleted</v-icon
                >
                <span class="premium-table-title mr-auto">Member Records</span>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Filter table..."
                  single-line
                  hide-details
                  outlined
                  dense
                  class="premium-table-search"
                ></v-text-field>
              </div>

              <v-data-table
                class="premium-data-table"
                v-model="selected1"
                :search="search"
                :item-key="tableOptions1.ItemKey"
                :single-select="tableOptions1.SingleSelectFlag"
                :show-select="tableOptions1.ShowSelectFlag"
                :headers="tableColumns1"
                :items="tableData1"
                :items-per-page="tableOptions1.ItemsPerPage"
                :footer-props="tableOptions1.FooterProps"
              >
                <!-- Image column slot -->
                <template v-slot:item.MemberImagePath="{ item }">
                  <div class="premium-avatar-wrapper">
                    <img
                      :src="item.MemberImagePath"
                      class="premium-avatar"
                      @error="
                        (e) => {
                          e.target.src = '/assets/images/white-user.png';
                        }
                      "
                    />
                  </div>
                </template>

                <!-- Status column slot -->
                <template v-slot:item.ActiveStatusTxt="{ item }">
                  <v-chip
                    :color="getActiveStatusColor(item.ActiveStatusTxt)"
                    class="premium-status-chip"
                    draggable
                    dark
                    small
                  >
                    {{ item.ActiveStatusTxt }}
                  </v-chip>
                </template>

                <!-- Actions Slot -->
                <template v-slot:item.actions="{ item }">
                  <div class="premium-table-actions">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          color="indigo"
                          class="premium-action-btn mr-1"
                          @click="previewData(item, e)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon size="18">mdi-file-search</v-icon>
                        </v-btn>
                      </template>
                      <span>Preview Details</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          color="amber darken-3"
                          class="premium-action-btn"
                          @click="editAlert(item, e)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon size="18">mdi-file-document-edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit Member</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </div>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import MemberEdit from "@/view/pages/members/MemberEdit.vue";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {
    MemberEdit,
  },
  data() {
    return {
      search: "",
      ProgessStart: 0,
      uploadPercentage: 0,

      SuccessMessageTxtFlag: 0,
      SuccessMessageTxt: "",

      ErrorMessageTxtFlag: 0,
      ErrorMessageTxt: "",

      DownloadFlag: false,
      ExcelFileName: "",
      ExcelFields: {},

      ZipDownloadFlag: false,
      ZipFileName: "",

      ZipQrDownloadFlag: false,
      ZipQrFileName: "",

      SelectFlag: true,
      DeleteFlag: false,

      alert: {},

      valid: true,

      JciYearCodeFlag: false,
      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCode: "",
      JciYearCodeOptions: [],

      MemberTypeRules: [],
      MemberType: [],
      MemberTypeOptions: [
        { value: 1, text: "Member" },
        { value: 3, text: "JAC Member" },
        { value: 2, text: "Associate Member" },
      ],

      IdCardTypeRules: [],
      IdCardType: 0,
      IdCardTypeOptions: [
        { value: 0, text: "Not issued" },
        { value: 1, text: "Issued" },
      ],

      DownloadMemberPhotosRules: [],
      DownloadMemberPhotos: 0,
      DownloadMemberPhotosOptions: [
        { value: 0, text: "No" },
        { value: 1, text: "Yes" },
      ],

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],

      LomCodeRules: [],
      LomCode: "",
      LomCodeOptions: [],

      MemberNameRules: [(v) => !!v || "Name is required"],
      MemberEmailRules: [],
      MemberMobileNoRules: [],
      MemberAddressRules: [],
      MemberCityRules: [],

      totalActiveAwards: 0,
      totalPendingAwards: 0,

      lastDate: "15-JAN-2021 11:59 PM",

      RoleId: "",

      ResultFlag: 0,
      BtnShowFlag: 0,

      NewMembers: [],

      bgColor: "#778899",
      position: "top-right",
      fabActions: [
        /*
        {
          name: 'deleteBtn',
          icon: 'delete',
          color: 'red',
        },
        */
        {
          name: "previewBtn",
          icon: "search",
          color: "orange",
        },
      ],

      singleSelect: true,
      selected1: [],
      selected2: [],
      search: "",
      search2: "",
      loading: true,

      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,

      recordToEdit: "",

      PaymentPaidDate: "",
      menu2: false,

      dialog: false,
      dialogDelete: false,
      rows: [],
      tableData1: [],
      tableOptions1: [],
      tableColumns1: [],
      TotalMembers: 0,

      editedIndex: -1,
      editedItem: {
        name: "",
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: "",
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      FloatingButtonOptions: {},
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;
        this.JciYearCode = CurrentJciYearId;

        this.getZoneCodeOptions();
      }
    },
    rows: function () {
      console.log("watch rows");
      var rows = this.rows;
      var n1 = rows.length;
      var flag = n1 == 0 ? 0 : 1;
      console.log("n1=" + n1 + ", flag=" + flag);
      this.ResultFlag = flag;
      if (n1 > 0) {
        var filter1 = {
          ActiveStatusTxt: "Active",
        };
        console.log("filter1=" + JSON.stringify(filter1));
        var records1 = rows;
        records1 = records1.filter(function (item) {
          for (var key in filter1) {
            if (item[key] === undefined || item[key] != filter1[key])
              return false;
          }
          return true;
        });
        var n2 = records1.length;
        console.log("n2=" + n2 + ", records1=" + JSON.stringify(records1));

        var filter2 = {
          ActiveStatusTxt: "Pending",
        };
        console.log("filter2=" + JSON.stringify(filter2));
        var records2 = rows;
        records2 = records2.filter(function (item) {
          for (var key in filter2) {
            if (item[key] === undefined || item[key] != filter2[key])
              return false;
          }
          return true;
        });
        var n3 = records2.length;
        console.log("n3=" + n3 + ", records2=" + JSON.stringify(records2));

        this.totalActiveAwards = n2;
        this.totalPendingAwards = n3;
      }
    },
    IdCardType: function () {
      console.log("watch IdCardType");
      var IdCardType = this.IdCardType;
      console.log({ IdCardType });
      this.tableData1 = [];
      this.selected1 = [];
      this.DownloadMemberPhotos = 0;
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    rowSelected(tr) {
      console.log("rowSelected called");
      console.log("tr=" + JSON.stringify(tr));
    },
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
    },
    resetMessageTxt() {
      console.log("resetMessageTxt called");
      this.ErrorMessageTxt = 0;
      this.ErrorMessageTxtFlag = "";
      this.SuccessMessageTxtFlag = 0;
      this.SuccessMessageTxt = "";
      this.totalActiveAwards = 0;
      this.totalPendingAwards = 0;
    },
    previewData(tr) {
      console.log("previewData called");
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        var id = tr.MemberId;
        // var id = 1;
        console.log("id=" + id);
        // var url = "/lom-single";
        var url = "/member-individual";
        var params = {
          id: id,
        };
        this.pageRedirect(params, url);
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    previewAlert(tr) {
      console.log("previewAlert called");
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.recordToEdit = 1;
        this.previewRecordPrompt = true;
        this.selected = tr.AwardsId;
      } else {
        var message = "Kindly select one record to preview";
        this.errorMessage(message);
      }
    },
    hideEditRecordPrompt() {
      console.log("hideEditRecordPrompt called");
      this.editRecordPrompt = false;
      this.searchForm();
    },
    editAlert(tr) {
      console.log("editAlert called");
      console.log({ tr });
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var id = tr.MemberId;
        console.log({ id });
        this.recordToEdit = id;
        this.editRecordPrompt = true;
      } else {
        var message = "Kindly select one record to edit";
        this.errorMessage(message);
      }
    },
    deleteAlert(tr) {
      console.log("deleteAlert called");
      console.log("tr=" + JSON.stringify(tr));
    },
    addNewRow(tableId) {
      console.log("addNewRow called");
      console.log("tableId=" + tableId);
      if (tableId == 1) {
        var n1 = this.AllDesignation.length;
        console.log("n1=" + n1);
        if (n1 < 5) {
          this.AllDesignation.push({
            year: "",
            level: "",
            position: "",
          });
        }
      }

      if (tableId == 2) {
        var n1 = this.NewMembers.length;
        console.log("n1=" + n1);
        if (n1 < 30) {
          this.NewMembers.push({
            MemberName: "",
            MemberEmail: "",
            MemberMobileNo: "",
            MemberAddress: "",
            MemberCity: "",
          });
        }
      }
    },
    deleteRow(tableId, index, tr) {
      console.log("deleteRow called");
      console.log(
        "tableId=" + tableId + ", index=" + index + ", tr=" + JSON.stringify(tr)
      );
      if (index > -1) {
        if (tableId == 1) {
          this.AllDesignation.splice(index, 1);
        }
        if (tableId == 2) {
          this.NewMembers.splice(index, 1);
        }
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jci_india_members",
        Action: "report_2",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    getJciYearCodeOptions() {
      console.log("getJciYearCodeOptions called");
      var selectbox1_source = "JciYearCode";
      var selectbox1_destination = "JciYearCodeOptions";
      var selectbox1_url = "api/jci-year/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        LomCode: 3,
        ZoneCode: 2,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getFormFieldOptions() {
      console.log("getFormFieldOptions called");
      // this.getContributionTypeIdOptions();
      this.getZoneCodeOptions();
    },
    getContributionTypeIdOptions() {
      console.log("getContributionTypeIdOptions called");
      var yearCode = this.JciYearCode;
      console.log("yearCode=" + yearCode);
      if (yearCode != "") {
        var selectbox1_source = "ContributionTypeId";
        var selectbox1_destination = "ContributionTypeIdOptions";
        var selectbox1_url = "api/year-wise-contribution/type-options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          YearCode: yearCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "Jci Year should not be empty";
        this.alert = {
          flag: true,
          color: "error",
          message: message,
        };
      }
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var yearCode = this.JciYearCode;
      console.log("yearCode=" + yearCode);
      if (yearCode != "") {
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-lom/zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: yearCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (yearCode == "") {
          message += "Year should not be empty. ";
        }
        this.alert = {
          flag: true,
          color: "error",
          message: message,
        };
      }
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var YearCode = this.JciYearCode;
      var ZoneCode = this.ZoneCode;
      console.log("YearCode=" + YearCode + ", ZoneCode=" + ZoneCode);
      if (YearCode != "" && ZoneCode != "") {
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          YearCode: YearCode,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        if (ZoneCode == "") {
          message += "Zone should not be empty. ";
        }
        this.alert = {
          flag: true,
          color: "error",
          message: message,
        };
      }
    },
    searchForm() {
      console.log("searchForm called");

      this.resetMessageTxt();

      var LomCode = this.LomCode;
      var ZoneCode = this.ZoneCode;
      var YearCode = this.JciYearCode;
      console.log("ZoneCode=" + ZoneCode + ", YearCode=" + YearCode);

      var result = this.$refs.form.validate();
      console.log("result=" + result);

      if (result) {
        this.DownloadFlag = false;
        this.ExcelFileName = "";
        this.ZipDownloadFlag = false;
        this.ZipFileName = "";
        this.ZipQrDownloadFlag = false;
        this.ZipQrFileName = "";
        this.tableData1 = [];
        this.selected1 = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/reports/members-id-card";
        var upload = {
          UserInterface: 1,
          Zone: ZoneCode,
          Lom: LomCode,
          Year: YearCode,
          MemberType: this.MemberType,
          IdCardType: this.IdCardType,
          DownloadMemberPhotos: this.DownloadMemberPhotos,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = [];
        var table_content = [];
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        // thisIns.pageLoadingOn()
        thisIns.ProgessStart = 1;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.ProgessStart = 0;

            output = response.data.output;
            flag = response.data.flag;
            table_content = response.data.records;
            console.log("output=" + output + ", flag=" + flag);

            var options = table_content.TableOptions;
            records = table_content.TableData;

            if (flag == 1) {
              thisIns.tableColumns1 = table_content.TableHeader;
              thisIns.tableOptions1 = options;
              thisIns.tableData1 = records;

              thisIns.DownloadFlag = options.DownloadFlag;
              thisIns.ExcelFileName = options.ExcelFileName;
              thisIns.ExcelFields = options.ExcelFields;
              thisIns.ZipDownloadFlag = options.ZipDownloadFlag;
              thisIns.ZipFileName = options.ZipFileName;
              thisIns.ZipQrDownloadFlag = options.ZipQrDownloadFlag;
              thisIns.ZipQrFileName = options.ZipQrFileName;

              thisIns.toast("success", output);
            } else {
              console.log("error=" + output);
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
          });
      } else {
        var message = "Kindy fill required fields and then submit";
        this.toast("error", message);
      }
    },
    updateConfirmAlert() {
      this.resetMessageTxt();

      var selected = this.selected1;
      var n1 = selected.length;
      console.log("n1=" + n1 + ", selected=" + JSON.stringify(selected));

      var result = this.$refs.form.validate();
      console.log("result=" + result);

      if (n1 > 0 && result) {
        Swal.fire({
          title: "Do you want to continue?",
          text: "Please verify all the information before proceeding.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            var upload = {
              Year: this.JciYearCode,
              Members: selected,
            };
            this.updateRecords(upload);
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "";
        if (!result) {
          message += "Kindly fill the required fields. ";
        }
        if (n1 == 0) {
          message += "Atleast select one member to update. ";
        }
        this.toast("error", message);
      }
    },
    updateRecords(upload) {
      console.log("updateRecords called");

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/reports/issued-cards-update";
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var successTxt = "";
      var errorTxt = "";
      var flag = 0;

      // thisIns.pageLoadingOn()
      thisIns.ProgessStart = 1;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          // thisIns.pageLoadingOff()
          thisIns.ProgessStart = 0;

          output = response.data.output;
          flag = response.data.flag;
          output = response.data.output;
          records = response.data.records;
          console.log("output=" + output + ", flag=" + flag);
          successTxt = response.data.success;
          errorTxt = response.data.error;
          console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

          if (flag == 1) {
            thisIns.tableData1 = [];
            thisIns.searchForm();
            thisIns.sweetAlert("success", output, true);
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
        });
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap");

.premium-dashboard {
  font-family: "Outfit", "Plus Jakarta Sans", sans-serif;
  background-color: #f6f8fc;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  padding: 12px;
}

/* Floating light ambient background orbs */
.glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  pointer-events: none;
  opacity: 0.45;
  z-index: 0;
}

.orb-1 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, #42a5f5 0%, rgba(21, 101, 192, 0) 70%);
  top: -100px;
  right: -50px;
}

.orb-2 {
  width: 500px;
  height: 500px;
  background: radial-gradient(
    circle,
    rgba(21, 101, 192, 0.2) 0%,
    rgba(66, 165, 245, 0) 70%
  );
  bottom: -150px;
  left: -100px;
}

.premium-page-wrapper {
  // Staggered Fade-in animation
  .fade-in {
    animation: premiumFadeIn 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  // Elevate the main container card
  .premium-main-card {
    border-radius: 20px !important;
    border: 1px solid rgba(226, 232, 240, 0.8) !important;
    background: #ffffff !important;
    overflow: hidden;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.03) !important;
  }

  // Header section with premium radial background and glow effect
  .premium-header-section {
    background: linear-gradient(
      135deg,
      #1565c0 0%,
      #1a73e8 45%,
      #42a5f5 100%
    ) !important;
    border-radius: 20px !important;
    color: white;
    box-shadow: 0 16px 40px rgba(21, 101, 192, 0.25) !important;
    overflow: hidden;
    position: relative;
    z-index: 1;
    padding: 40px 32px 48px 32px;

    .hero-glow-effect {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.1) 0%,
        rgba(255, 255, 255, 0) 100%
      );
      z-index: 0;
      pointer-events: none;
    }

    .hero-glow-effect::after {
      content: "";
      position: absolute;
      top: 0;
      left: -50%;
      width: 200%;
      height: 100%;
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.15) 30%,
        rgba(255, 255, 255, 0) 60%
      );
      transform: skewX(-25deg);
      animation: shineSweep 6s infinite ease-in-out;
    }

    .premium-badge-top {
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.15em;
      color: #ffffff;
      background: rgba(255, 255, 255, 0.12);
      padding: 6px 12px;
      border-radius: 100px;
      display: inline-block;
      margin-bottom: 12px;
      border: 1px solid rgba(255, 255, 255, 0.2);
    }

    .premium-page-title {
      font-size: 28px !important;
      font-weight: 800 !important;
      margin-bottom: 6px;
      letter-spacing: -0.8px;
      line-height: 1.2;
      color: #ffffff !important;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }

    .premium-page-subtitle {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.95);
      margin-bottom: 0;
      font-weight: 400;
      max-width: 600px;
    }

    .premium-title-icon {
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }

    .refresh-btn {
      backdrop-filter: blur(8px);
      border: 1px solid rgba(255, 255, 255, 0.25) !important;
      transition: all 0.3s ease !important;

      &:hover {
        transform: rotate(180deg) scale(1.1);
        background-color: rgba(255, 255, 255, 0.25) !important;
      }
    }
  }

  /* Decorative background icons */
  .deco-icon {
    position: absolute !important;
    z-index: 1;
    pointer-events: none;
  }

  .icon-card {
    font-size: 110px !important;
    right: 20%;
    top: -20px;
    transform: rotate(15deg);
    animation: floatDeco 12s infinite ease-in-out;
  }

  .icon-receipt {
    font-size: 80px !important;
    left: 10%;
    bottom: -15px;
    transform: rotate(-10deg);
    animation: floatDeco 15s infinite ease-in-out alternate;
  }

  .icon-safe {
    font-size: 90px !important;
    right: 5%;
    bottom: -10px;
    transform: rotate(20deg);
    animation: floatDeco 10s infinite ease-in-out;
  }

  .icon-coin {
    font-size: 70px !important;
    left: 50%;
    top: -30px;
    opacity: 0.8;
    animation: floatDeco 14s infinite ease-in-out alternate;
  }

  /* Specific text and icon animations */
  .animate-title {
    animation: slideInLeft 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  .animate-subtitle {
    opacity: 0;
    animation: slideInLeft 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.15s forwards;
  }

  .pulse-animation {
    animation: pulseIcon 3s infinite ease-in-out;
  }

  .spin-pulse-icon {
    animation: pulseGlowIcon 2s infinite ease-in-out;
  }

  .pulse-border {
    animation: borderGlow 4s infinite ease-in-out;
  }

  /* Ocean Wave Styling */
  .waves-container {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 40px;
    min-height: 40px;
    max-height: 60px;
    z-index: 1;
  }

  .waves {
    position: relative;
    width: 100%;
    height: 40px;
    margin-bottom: -7px;
  }

  .parallax > use {
    animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
  }

  .parallax > use:nth-child(1) {
    animation-delay: -2s;
    animation-duration: 7s;
  }

  .parallax > use:nth-child(2) {
    animation-delay: -3s;
    animation-duration: 10s;
  }

  .parallax > use:nth-child(3) {
    animation-delay: -4s;
    animation-duration: 13s;
  }

  .parallax > use:nth-child(4) {
    animation-delay: -5s;
    animation-duration: 20s;
  }

  .relative-content {
    position: relative;
    z-index: 2;
  }

  .premium-card-content {
    padding: 32px !important;
  }

  // Search filter panel styling (glassmorphism)
  .premium-filter-panel.glass-card {
    background: rgba(255, 255, 255, 0.82) !important;
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.7) !important;
    border-radius: 20px !important;
    box-shadow: 0 10px 30px rgba(33, 33, 33, 0.04) !important;
    padding: 28px;
    margin-bottom: 32px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 15px 35px rgba(21, 101, 192, 0.08) !important;
    }

    .premium-panel-header {
      background: linear-gradient(90deg, #1565c0 0%, #1e88e5 100%);
      padding: 14px 24px;
      margin: -28px -28px 24px -28px;
      border-radius: 20px 20px 0 0;
      color: white;
      display: flex;
      align-items: center;

      .premium-panel-title {
        font-size: 16px;
        font-weight: 700;
        color: white !important;
      }
    }
  }

  // Form input elements styling
  .premium-input-group {
    display: flex;
    flex-direction: column;

    .premium-input-label {
      font-size: 12px;
      font-weight: 700;
      color: #455a64;
      margin-bottom: 6px;
      display: block;
    }
  }

  // Customize Vuetify Auto-complete dropdowns to look exactly like Jcsat
  .premium-select.v-text-field--outlined {
    .v-input__control > .v-input__slot {
      border-radius: 12px !important;
      border: 1.5px solid rgba(21, 101, 192, 0.1) !important;
      background-color: white !important;
      transition: all 0.3s ease !important;
      min-height: 44px !important;

      fieldset {
        border: none !important;
      }
    }

    &:hover .v-input__control > .v-input__slot {
      border-color: rgba(21, 101, 192, 0.35) !important;
    }

    &.v-input--is-focused .v-input__control > .v-input__slot {
      border-color: #1565c0 !important;
      box-shadow: 0 0 0 3px rgba(21, 101, 192, 0.15) !important;
    }

    .v-input__append-inner {
      margin-top: 10px !important;
    }

    .v-select__selections {
      padding: 4px 0 !important;
    }

    .v-chip {
      border-radius: 6px !important;
      font-weight: 600 !important;
      background-color: rgba(21, 101, 192, 0.08) !important;
      color: #1565c0 !important;
      border: 1px solid rgba(21, 101, 192, 0.15) !important;
      font-size: 11px !important;
      height: 24px !important;
      margin: 2px !important;

      .v-chip__close {
        color: #1565c0 !important;
        font-size: 14px !important;
      }
    }
  }

  // Premium actions row inside filter panel
  .premium-actions-row {
    display: flex;
    justify-content: flex-end;
  }

  // Premium button styles
  .premium-btn {
    text-transform: none !important;
    font-weight: 700 !important;
    letter-spacing: 0.2px !important;
    border-radius: 10px !important;
    height: 46px !important;
    box-shadow: none !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;

    &:active {
      transform: scale(0.97);
    }
  }

  .premium-btn-search {
    background: linear-gradient(135deg, #1565c0 0%, #1e88e5 100%) !important;
    box-shadow: 0 6px 20px rgba(21, 101, 192, 0.3) !important;
    color: #ffffff !important;
    border: none !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(21, 101, 192, 0.45) !important;
    }
  }

  .premium-btn-mark {
    background: linear-gradient(135deg, #e53935 0%, #c62828 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 4px 14px rgba(229, 57, 53, 0.2) !important;

    &:hover {
      box-shadow: 0 6px 20px rgba(229, 57, 53, 0.3) !important;
    }
  }

  .premium-btn-download-details {
    background: linear-gradient(135deg, #2e7d32 0%, #4caf50 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 4px 15px rgba(46, 125, 50, 0.25) !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(46, 125, 50, 0.4) !important;
    }
  }

  .premium-btn-download-photos {
    background: linear-gradient(135deg, #0288d1 0%, #01579b 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 4px 14px rgba(2, 136, 209, 0.2) !important;

    &:hover {
      box-shadow: 0 6px 20px rgba(2, 136, 209, 0.3) !important;
    }
  }

  .premium-btn-download-qr {
    background: linear-gradient(135deg, #00796b 0%, #004d40 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 4px 14px rgba(0, 121, 107, 0.2) !important;

    &:hover {
      box-shadow: 0 6px 20px rgba(0, 121, 107, 0.3) !important;
    }
  }

  // Loader state styling
  .premium-state-container {
    .premium-loader-wrapper {
      position: relative;
      background: #ffffff;
      border: 1px dashed #cbd5e1;
      border-radius: 16px;
      overflow: hidden;

      .premium-shimmer-bar {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 3px;
        background: linear-gradient(
          90deg,
          #1565c0 25%,
          #42a5f5 50%,
          #1565c0 75%
        );
        background-size: 200% 100%;
        animation: shimmer 1.5s infinite linear;
      }

      .premium-loader-text {
        font-size: 0.9rem;
        font-weight: 500;
        color: #475569;
        letter-spacing: 0.01em;
      }
    }

    // Empty state styling
    .premium-empty-state {
      background: rgba(255, 255, 255, 0.82) !important;
      backdrop-filter: blur(20px);
      border: 1px dashed rgba(21, 101, 192, 0.25) !important;
      border-radius: 20px !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .premium-empty-title {
        font-size: 18px;
        font-weight: 700;
        color: #37474f;
        margin-top: 16px;
      }

      .premium-empty-subtitle {
        font-size: 13px;
        color: #78909c;
        max-width: 420px;
        margin: 6px auto 0;
      }
    }
  }

  // Results Section Header
  .premium-results-section {
    .premium-results-title {
      font-size: 16px;
      font-weight: 700;
      color: #263238;
      letter-spacing: -0.02em;
      margin-bottom: 0;
    }

    .premium-badge {
      font-size: 0.75rem;
      font-weight: 600;
      padding: 4px 10px;
      border-radius: 100px;
      display: inline-flex;
      align-items: center;

      &.premium-badge-found {
        background-color: rgba(76, 175, 80, 0.08);
        color: #2e7d32;
        border: 1px solid rgba(76, 175, 80, 0.15);
      }

      &.premium-badge-selected {
        background-color: rgba(21, 101, 192, 0.06);
        color: #1565c0;
        border: 1px solid rgba(21, 101, 192, 0.12);
      }
    }
  }

  // Premium table card wrapper
  .premium-table-card {
    background: #ffffff !important;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    overflow: hidden;

    .premium-table-header-row {
      border-bottom: 1px solid #e2e8f0;
      background-color: #f8fafc;

      .premium-table-title {
        font-size: 0.95rem;
        font-weight: 700;
        color: #334155;
        letter-spacing: -0.01em;
      }

      .premium-table-search {
        max-width: 280px;

        .v-input__control > .v-input__slot {
          border-radius: 12px !important;
          border: 1.5px solid rgba(21, 101, 192, 0.12) !important;
          background-color: rgba(21, 101, 192, 0.01) !important;
          min-height: 36px !important;

          fieldset {
            border: none !important;
          }
        }

        &.v-input--is-focused .v-input__control > .v-input__slot {
          border-color: #1565c0 !important;
          box-shadow: 0 0 0 3px rgba(21, 101, 192, 0.12) !important;
          background-color: white !important;
        }
      }
    }
  }

  // Premium Vuetify data table styles with "bigg" font sizes
  .premium-data-table {
    border-radius: 0 0 16px 16px;

    table {
      border-collapse: separate;
      border-spacing: 0;
    }

    th {
      font-size: 16px !important; // Increased font size to bigg
      font-weight: 700 !important;
      text-transform: uppercase !important;
      letter-spacing: 0.05em !important;
      color: #1565c0 !important; // Approved color
      background-color: rgba(
        21,
        101,
        192,
        0.04
      ) !important; // Approved bg color
      border-bottom: 2px solid rgba(21, 101, 192, 0.08) !important;
      height: 52px !important;
    }

    tr {
      transition: background-color 0.2s ease;

      &:hover {
        background-color: rgba(
          21,
          101,
          192,
          0.03
        ) !important; // Approved hover bg
      }
    }

    td {
      font-size: 15px !important; // Increased font size to bigg
      color: #37474f !important; // Approved text color
      border-bottom: 1px solid rgba(21, 101, 192, 0.04) !important;
      height: 60px !important;
    }

    // Avatar wrapper inside table
    .premium-avatar-wrapper {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      overflow: hidden;
      border: 2px solid #e2e8f0;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      background-color: #f8fafc;
      display: flex;
      align-items: center;
      justify-content: center;

      .premium-avatar {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    // Status chips
    .premium-status-chip {
      font-size: 0.8rem !important;
      font-weight: 700 !important;
      height: 24px !important;
      border-radius: 100px !important;
      letter-spacing: 0.02em !important;
      padding: 0 12px !important;
    }

    // Action button circles
    .premium-action-btn {
      border: 1px solid #e2e8f0 !important;
      background-color: #ffffff !important;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;

      &:hover {
        transform: scale(1.18);
        background: rgba(21, 101, 192, 0.08) !important;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05) !important;
        border-color: #1565c0 !important;
      }
    }
  }

  // Custom sweetalert modifications (can style custom classes inside main app dialogs)
  .premium-dialog {
    border-radius: 20px !important;
    overflow: hidden !important;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }
}

// Keyframes definitions
@keyframes shineSweep {
  0% {
    left: -120%;
  }
  15%,
  100% {
    left: 120%;
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes floatDeco {
  0%,
  100% {
    transform: translateY(0) rotate(15deg) scale(1);
  }
  50% {
    transform: translateY(-12px) rotate(20deg) scale(1.03);
  }
}

@keyframes pulseIcon {
  0%,
  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  }
  50% {
    transform: scale(1.08);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.6));
  }
}

@keyframes pulseGlowIcon {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
}

@keyframes borderGlow {
  0%,
  100% {
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  }
  50% {
    border-color: rgba(255, 255, 255, 0.45);
    box-shadow: 0 4px 25px rgba(255, 255, 255, 0.15);
  }
}

@keyframes premiumFadeIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>

